// extracted by css-extract-rspack-plugin
export default {"cls1":"library_button_search_redesign-cls1_KkN","cls2":"library_button_search_redesign-cls2_JFB library_button_search_redesign-cls1_KkN"};